'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'fire';
var width = 448;
var height = 512;
var aliases = [128293];
var unicode = 'f06d';
var svgPathData = 'M285.9 58.2c-4.2 5-9 11-14.2 17.9-15.7-25.9-31.8-47.6-45.3-64.2-15.5-19-31.8-35.4-49.5-52.1-14.6 12.3-28.4 24.2-41.8 38-14.9 15.3-34.7 37.5-54.6 65.1-39.4 55-80.5 133.9-80.5 225 0 123.7 100.3 224 224 224S448 411.7 448 288c0-70.3-28.4-132.7-55.6-176.6-13.7-22.1-27.4-40-37.7-52.4-10.5-12.6-22-24.1-33.6-35.7l0 0-1.1-1.1c-.6 .6-1.2 1.2-1.9 1.9-11.2 11.2-22.1 22-32.3 34.3zM225.7 416c-63.2 0-113.7-40.6-113.7-109.2 0-65.6 63.2-114.8 63.2-114.8 5.6 7 87.1 110.6 87.1 110.6l50.6-58.8c4.2 5.6 7 11.2 9.8 16.8 25.3 46.2 14 105-28.1 134.4-21.1 14-43.5 21-68.8 21z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFire = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;